module.exports = __webpack_public_path__ + "img/change-pass.e6c3bfae.svg";